import { css } from "styled-components";

/**
 * Set hover styles only when primary input mechanism can hover over elements. May be useful to implement on inner elements of scrollable container to fix issues of scroll on iOS devices.
 *
 * @param styles - styles to implement when hover
 * @returns styles of hover state
 */
var setSafeHoverStyles = function setSafeHoverStyles(styles) {
  return css(["@media (hover){&:hover{", ";}}"], styles);
};
export default setSafeHoverStyles;